import { Card, CardHeader } from "@mui/material";
import PermissionsAvatar from "./PermissionsAvatar";
import { ITatPermissionModel } from "../../../../common/models/ITatPermissionModel";

import type { JSX } from "react";

export type TatPermissionsCardProps = {
    tatPermissions: ITatPermissionModel;
};

export default function TatPermissionsCard({
    tatPermissions
}: TatPermissionsCardProps): JSX.Element {
    return (
        <Card
            variant="elevation"
            elevation={4}
        >
            <CardHeader
                sx={{
                    padding: 1
                }}
                title={`Tag ${tatPermissions.tagAssociationTypeName}`}
                avatar={<PermissionsAvatar />}
                subheader={tatPermissions.hasDetail
                    ? `${tatPermissions.summary}: ${tatPermissions.summaryDetail}`
                    : `${tatPermissions.summary}`} />
        </Card>
    );
}
